import JcnrkList from './index.vue';

const routes = [
  {
    path: 'checkContent',
    name: 'checkContent',
    component: JcnrkList,
    meta: {
      title: '任务内容库',
      permission: 'iff:gnmk:checkContent:view',
      // 保留未关闭页签的页面状态，切换回来时不重新执行 mounted 初始化。
      isCache: true
    }
  }
];

export default routes;
